import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { useAuth } from '@/contexts/AuthContext';

interface Props {
  children: ReactNode;
}

export function RequireAuth({ children }: Props) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        role="status"
        aria-label="Authenticating"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user.is_engineer) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        Sorry, Sherlock is engineer-only.
      </Box>
    );
  }

  return <>{children}</>;
}
